import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { AuthRTKService } from '../../app/services/auth-rtk.service';
import { ChatbotRTKService } from '../../app/services/chatbot-rtk.services';
import { RootState } from '../../app/store';
import IAuthState from '../../interfaces/models/auth-state.interface';
import { IUser } from './auth.types';

const initialState: IAuthState = {
  is_authenticated: false,
  is_remember_me: false,
  is_impersonate: false,
  is_user_new: true,
  profile: null,
  error: null,
};

const AuthSlice: any = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login: (state, action: PayloadAction<{ [key: string]: any }>) => {
      state.is_remember_me = action.payload.is_remember_me;
      state.is_authenticated = true;
      state.error = null;
      if (action.payload.is_impersonate) {
        state.is_impersonate = true;
      } else {
        state.is_impersonate = false;
      }
    },

    logout: () => initialState,

    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
    },

    setProfile: (state, action: PayloadAction<IUser>) => {
      state.profile = action.payload;
    },

    setIsUserNew: (state, action: PayloadAction<boolean>) => {
      state.is_user_new = action.payload;
    },
    updateEmail: (state, action: PayloadAction<string>) => {
      state.profile = { ...state.profile, user_email: action.payload } as IUser;
    },
  },
  extraReducers: builder => {
    builder.addMatcher(ChatbotRTKService.endpoints.getPackage.matchRejected, (state, action) => {
      if (action?.payload?.status == 401) {
        state.is_authenticated = false;
      }
    });
    builder.addMatcher(ChatbotRTKService.endpoints.getAllScenarios.matchRejected, (state, action) => {
      if (action?.payload?.status == 401) {
        state.is_authenticated = false;
      }
    });

    builder.addMatcher(ChatbotRTKService.endpoints.getPackage.matchFulfilled, (state, action) => {
      if (action?.payload?.plan) {
        state.is_user_new = false;
      } else {
        state.is_user_new = true;
      }
    });

    builder.addMatcher(AuthRTKService.endpoints.getProfile.matchFulfilled, (state, action) => {
      state.profile = {
        ...action.payload,
      } as IUser;
    });
  },
});

export default AuthSlice.reducer;

export const { login, logout, setAccountStatus, setProfile, updateEmail, setError, setIsUserNew } = AuthSlice.actions;

export const selectUseId = (state: RootState) => state.authState?.profile?.user_identification;

export const selectIsRememberMe = (state: RootState) => state.authState?.is_remember_me;

export const selectUserProfile = (state: RootState) => state.authState?.profile as IUser;

export const selectIsImpersonate = (state: RootState) => state.authState?.is_impersonate as IUser;

export const selectUserAuthStatus = (state: RootState) => {
  return state.authState?.is_authenticated ? true : false;
};

export const selectError = (state: RootState) => {
  return state.authState?.error;
};

export const selectIsUserNew = (state: RootState) => {
  return state.authState?.is_user_new as boolean;
};
